import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14deea6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Summary")
], -1))
const _hoisted_3 = { class: "form-grid" }
const _hoisted_4 = { class: "form-group col-span-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Summary Title", -1))
const _hoisted_6 = { class: "form-group col-span-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description", -1))

import { ref, watch } from "vue";
import type { Summary } from "../../../../server/src/models/Resume";


export default /*#__PURE__*/_defineComponent({
  __name: 'SummarySection',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const summary = ref<Summary>({ ...props.modelValue });

watch(
  () => props.modelValue,
  (newValue) => {
    summary.value = { ...newValue };
  },
  { deep: true }
);

function emitUpdate() {
  emit("update:modelValue", { ...summary.value });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((summary.value.title) = $event)),
          type: "text",
          placeholder: "e.g., Career Objective, Professional Summary",
          class: "form-control",
          onInput: emitUpdate
        }, null, 544), [
          [_vModelText, summary.value.title]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((summary.value.description) = $event)),
          rows: "4",
          placeholder: "Describe your professional background and career goals...",
          class: "form-control",
          onInput: emitUpdate
        }, null, 544), [
          [_vModelText, summary.value.description]
        ])
      ])
    ])
  ]))
}
}

})